// Lodash
import _noop from 'lodash/noop';

// Constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';

// Builders
import ColumnConfig from '../../builders/ColumnConfig';
export var getFooterPropsForColumn = function getFooterPropsForColumn() {
  var columnConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new ColumnConfig();
  var data = arguments.length > 1 ? arguments[1] : undefined;
  var getFooterProps = columnConfig.getGetFooterProps() || _noop;
  var footerProps = getFooterProps(data);
  return footerProps;
};
export var getFooterClassName = function getFooterClassName() {
  var columnConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new ColumnConfig();
  var footerProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJECT;
  var footerClass = columnConfig.getFooterClassName() || '';
  var _footerProps$classNam = footerProps.className,
    className = _footerProps$classNam === void 0 ? '' : _footerProps$classNam;
  var footerClassName = "".concat(footerClass, " ").concat(className);
  return footerClassName;
};